import React from 'react';
import { withStyles } from "tss-react/mui";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import styles from './styles';

function DialogHeader(props) {
    const { classes, disableClose, showBackIcon, icon: Icon, config } = props;
    const shouldShowBack = Boolean(showBackIcon);

    return (
        <AppBar className={classes.appBar} color="primary" config={config}>
            <Toolbar>
                {!disableClose &&
                    <IconButton
                        title="Close"
                        color="inherit"
                        onClick={props.handleClose}
                        aria-label="Close"
                        size="large">
                        {!shouldShowBack &&
                            <CloseIcon />
                        }
                        {shouldShowBack &&
                            <ArrowBackIcon />
                        }

                    </IconButton>
                }
                {Icon &&
                    <Icon style={{ marginRight: 10 }} />
                }
                <Typography variant="h6" color="inherit" className={classes.flex} noWrap>
                    {props.title}
                </Typography>
            </Toolbar>
        </AppBar>
    );
}

DialogHeader.propTypes = {
    title: PropTypes.string.isRequired,
    handleClose: PropTypes.func,
    disableClose: PropTypes.bool,
    showBackIcon: PropTypes.bool,
    icon: PropTypes.func
};

export default withStyles(DialogHeader, styles);